import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    public globals: Globals,
    public authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  signOut(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  openShop(): void {
    window.open(environment.shopUrl);
  }
}
